<p-card>
  <div class="ir-head">
    <div>
      <h1 class="ir-title">Reglas de facturación</h1>
      <p class="ir-sub">
        Cuándo vence cada tipo de factura. De esa fecha salen los días de atraso, la mora y el «vencido al día de corte», así que la decide
        Contabilidad y queda con su motivo.
      </p>
    </div>
    <app-ayuda-cifra titulo="Por qué hay reglas y no una sola fecha">
      <p>
        La <b>renta</b> vence el día de su letra de la tabla de amortización: sale del contrato y no es configurable. Los demás rubros no
        tienen letra de la que sacarlo, y la hoja de Contabilidad tampoco lo trae.
      </p>
      <p>
        En la carga de septiembre <b>144 de 382 renglones llegaron sin fecha de pagaré</b>, casi todos de gestión vehicular, seguro, pago
        inicial, residuales y moratorios. Cada uno necesita su propia regla.
      </p>
      <p class="ay-ojo">
        Lo que está <b>sin definir</b> no vence: no acumula días de atraso ni genera mora. Es a propósito — mejor visible que con un
        vencimiento inventado que nadie sabría de dónde salió y que sí cobraría intereses.
      </p>
    </app-ayuda-cifra>
  </div>

  <!--
    El aviso solo aparece cuando hay algo que hacer, y lleva el número: «faltan reglas» no mueve a
    nadie; «60 facturas no vencen porque nadie ha definido su regla», sí.
  -->
  <div class="ir-alert" *ngIf="!cargando && pendientes.length">
    <i class="fa-solid fa-triangle-exclamation"></i>
    <span>
      <b>{{ facturasSinVencer }}</b> factura{{ facturasSinVencer === 1 ? '' : 's' }} no vence{{ facturasSinVencer === 1 ? '' : 'n' }} porque
      su clasificación todavía no tiene regla: <b>{{ pendientes.length }}</b> pendiente{{ pendientes.length === 1 ? '' : 's' }} de definir.
    </span>
  </div>

  <!--
    Distinto del aviso de arriba, y por eso va aparte: aquí no falta una regla, faltan las
    clasificaciones. Mandar a definir una regla para «sin clasificar» taparía el problema.
  -->
  <div class="ir-alert is-info" *ngIf="!cargando && sinClasificar">
    <i class="fa-solid fa-circle-info"></i>
    <span>
      Además hay <b>{{ sinClasificar!.withoutDueDate }}</b> factura{{ sinClasificar!.withoutDueDate === 1 ? '' : 's' }}
      <b>sin clasificar</b>. Ésas no se arreglan con una regla: se clasifican en <a routerLink="/cobranza/central">CENTRAL</a> y ahí toman
      la de su tipo.
    </span>
  </div>

  <p-skeleton height="18rem" *ngIf="cargando"></p-skeleton>

  <table class="ir-table" *ngIf="!cargando">
    <thead>
      <tr>
        <th>Tipo de factura</th>
        <th>Cuándo vence</th>
        <th class="ir-num">Facturas</th>
        <th class="ir-num">Sin vencer</th>
        <th>Quién la puso</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let r of reglas" [class.is-pending]="r.mode === 'UNDEFINED' && r.withoutDueDate > 0 && !esFija(r)">
        <td class="ir-name">
          {{ r.label }}
          <span
            class="ir-locked"
            *ngIf="esRenta(r)"
            pTooltip="Sale de la letra del contrato: es un dato del negocio, no una opinión"
            tooltipPosition="right"
          >
            <i class="fa-solid fa-lock"></i> fija
          </span>
          <span
            class="ir-locked"
            *ngIf="esSinClasificar(r)"
            pTooltip="No es un tipo de factura: es el hueco de las que nadie clasificó. Se resuelve clasificándolas en CENTRAL"
            tooltipPosition="right"
          >
            <i class="fa-solid fa-lock"></i> no aplica
          </span>
        </td>
        <td>
          <span class="ir-rule" [class.is-undef]="r.mode === 'UNDEFINED'">{{ enPalabras(r) }}</span>
          <!-- Las notas son el porqué que Contabilidad dejó escrito; sin ellas la regla es un dato suelto. -->
          <div class="ir-notes" *ngIf="r.notes">{{ r.notes }}</div>
        </td>
        <td class="ir-num">{{ r.invoices || '—' }}</td>
        <td class="ir-num" [class.is-bad]="r.withoutDueDate > 0">{{ r.withoutDueDate || '—' }}</td>
        <td class="ir-who">
          <ng-container *ngIf="r.updatedByName">{{ r.updatedByName }} · {{ r.updatedAt | date: 'dd/MM/yy' }}</ng-container>
          <!--
            «Propuesta nuestra» y no «sin confirmar»: dice de quién es la regla que está puesta, que
            es lo que hace falta para saber si hay que revisarla.
          -->
          <span class="ir-seed" *ngIf="!r.updatedByName && !esFija(r)">propuesta nuestra, sin confirmar</span>
          <span class="ir-seed" *ngIf="!r.updatedByName && esRenta(r)">del contrato</span>
          <span class="ir-seed" *ngIf="!r.updatedByName && esSinClasificar(r)">—</span>
        </td>
        <td class="ir-act">
          <button
            *ngIf="!esFija(r) && puedeEditar"
            pButton
            type="button"
            [label]="r.mode === 'UNDEFINED' ? 'Definir' : 'Cambiar'"
            class="p-button-sm p-button-text"
            (click)="abrir(r)"
          ></button>
        </td>
      </tr>
    </tbody>
  </table>
</p-card>

<p-dialog
  [visible]="!!editando"
  (visibleChange)="!$event && cerrar()"
  [modal]="true"
  [closable]="!guardando"
  [header]="'Cuándo vence: ' + (editando?.label || '')"
  styleClass="ir-dialog"
  [style]="{ width: '520px' }"
>
  <div class="ir-form" *ngIf="editando">
    <p class="ir-lead" *ngIf="editando.withoutDueDate">
      Hay <b>{{ editando.withoutDueDate }}</b> factura{{ editando.withoutDueDate === 1 ? '' : 's' }} de este tipo sin fecha de vencimiento.
      Al guardar se les calculará con la regla que elijas.
    </p>

    <label for="ir-modo">Regla</label>
    <p-dropdown
      inputId="ir-modo"
      [options]="modos"
      [(ngModel)]="modo"
      optionLabel="label"
      optionValue="value"
      styleClass="w-full"
      appendTo="body"
    ></p-dropdown>
    <small class="ir-help">{{ ayudaDelModo }}</small>

    <ng-container *ngIf="modo === 'DAYS_AFTER'">
      <label for="ir-dias">Días después de la emisión</label>
      <!--
        Sin `showButtons`: en su disposición por omisión PrimeNG apila las dos flechas y el control
        crece a tres veces el alto de los demás campos, rompiendo el ritmo del formulario. Para
        escribir un número de días el teclado basta, y el rango lo defienden `min`/`max` y el backend.
      -->
      <p-inputNumber inputId="ir-dias" [(ngModel)]="dias" [min]="0" [max]="365" [useGrouping]="false" styleClass="ir-dias"></p-inputNumber>
      <small class="ir-help" *ngIf="dias === 0">Cero días es lo mismo que «el mismo día que se emite».</small>
    </ng-container>

    <label for="ir-notas">Notas <span class="ir-opt">(opcional)</span></label>
    <textarea
      id="ir-notas"
      pInputTextarea
      [(ngModel)]="notas"
      rows="2"
      placeholder="Lo que quieras dejar escrito sobre por qué la regla es así"
    ></textarea>

    <!--
      Obligatorio, y el backend también lo exige. El vencimiento mueve la mora: sin el motivo, dentro
      de seis meses nadie podrá explicar por qué una factura vencía en otra fecha.
    -->
    <label for="ir-motivo">Motivo del cambio</label>
    <textarea id="ir-motivo" pInputTextarea [(ngModel)]="motivo" rows="2" placeholder="Queda en el historial de la regla"></textarea>
    <small class="ir-hint" *ngIf="motivo && !motivoSuficiente">Escríbelo con algo más de detalle — queda en el historial.</small>

    <small class="ir-err" *ngIf="errorAlGuardar">{{ errorAlGuardar }}</small>
  </div>

  <ng-template pTemplate="footer">
    <button pButton type="button" label="Cancelar" class="p-button-text" [disabled]="guardando" (click)="cerrar()"></button>
    <button
      pButton
      type="button"
      label="Guardar"
      icon="fa-solid fa-check"
      [loading]="guardando"
      [disabled]="!puedeGuardar"
      (click)="guardar()"
    ></button>
  </ng-template>
</p-dialog>

<p-toast position="top-right"></p-toast>
